'use strict';
module.exports = require('../../full/observable');
